import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListImport from '../../components/import-export/list-import.component';
import ListExport from '../../components/import-export/list-export.component';
import useAccess from '../../hooks/access.hook';

const ImportView = () => {
  const pageTitle = 'Data Management / Import - Export';
  const { hasAccess } = useAccess();

  return (
    <AppLayout pageTitle={pageTitle}>
      {hasAccess('import') && <ListImport />}
      {hasAccess('export') && <ListExport />}
    </AppLayout>
  );
};

export default ImportView;
